import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import SvgIcon from '@mui/material/SvgIcon';
import ReclamationsSearchFilters from './ReclamationsSearchFilters';
import ReclamationsSearchResults from './ReclamationsSearchResults';
import ReclamationsDrawerListItem from './ReclamationsDrawerListItem';
import ReclamationTooltip from './ReclamationTooltip';
import { ReclamationFiltre } from '../../../constants';
import { ReclamationFiltreNoms } from '../../../constants';
import localStorageHelper from 'utils/localStorageHelper';

const drawerWidth = 50;
const drawerFullWidth = 225;

const styles = theme => ({
    root: {
        padding: 0,
        flexGrow: 1,
        position: 'relative',
        display: 'flex'
    },
    content: {
        padding: 20,
        flexGrow: 0,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        marginLeft: drawerWidth,
        backgroundColor: theme.palette.background.primary,
        minWidth: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['margin-left', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    contentClose: {
        transition: theme.transitions.create(['margin-left', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: drawerFullWidth,
        minWidth: `calc(100% - ${drawerFullWidth}px)`
    },
    drawerPaper: {
        overflow: 'visible',
        position: 'fixed',
        top: 72,
        flex: '0 0 auto',
        boxsizing: 'inherit',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        width: drawerFullWidth
    },
    drawerFooter: {
        position: 'fixed',
        bottom: 0,
        width: 'inherit'
    },
    listItemIcon: {
        margin: 0,
        padding: 0
    },
    listItem: {
        paddingRight: 8,
        paddingLeft: 12
    },
    divider: {
        margin: '10px 0'
    }
});

class ReclamationsPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    getAnchor() {
        return (document.URL.split('#').length > 1) ? document.URL.split('#')[1] : null;
    }

    toggleExpanded = () => {
        this.setState({ ...this.state, expanded: !this.state.expanded });
    }
    
    render() {
        const { classes, filtre } = this.props;
        const { expanded } = this.state;

        const utilisateurMagasin = localStorageHelper.getUtilisateurMagasin();
        const connexionRepresentant = localStorageHelper.getConnexionRepresentant();

        //let anchor = this.getAnchor();

        //let filtre = ReclamationFiltreNoms.findIndex(x => x === anchor);
        //if (filtre === -1) {
        //    filtre = ReclamationFiltre.MaSelection;
        //}

        return (
            <div className={classes.root}>
                <Drawer variant="permanent" classes={{ paper: classNames(classes.drawerPaper, expanded && classes.drawerPaperClose) }}>
                    <List component="nav">
                        <ReclamationTooltip expanded={expanded} />

                        <Divider className={classes.divider} />
                        
                        <ReclamationsDrawerListItem expanded={expanded} selected={filtre === ReclamationFiltre.MaSelection} filtre={ReclamationFiltre.MaSelection} anchor={ReclamationFiltreNoms[ReclamationFiltre.MaSelection]}/>
                        {!connexionRepresentant && <ReclamationsDrawerListItem expanded={expanded} selected={filtre === ReclamationFiltre.Commentaires} filtre={ReclamationFiltre.Commentaires} anchor={ReclamationFiltreNoms[ReclamationFiltre.Commentaires]} />}
                        {!connexionRepresentant && <ReclamationsDrawerListItem expanded={expanded} selected={filtre === ReclamationFiltre.Cloturees} filtre={ReclamationFiltre.Cloturees} anchor={ReclamationFiltreNoms[ReclamationFiltre.Cloturees]} />}
                        {!connexionRepresentant && <ReclamationsDrawerListItem expanded={expanded} selected={filtre === ReclamationFiltre.AVerifier} filtre={ReclamationFiltre.AVerifier} anchor={ReclamationFiltreNoms[ReclamationFiltre.AVerifier]} />}
                        {!connexionRepresentant && <ReclamationsDrawerListItem expanded={expanded} selected={filtre === ReclamationFiltre.ARelancer} filtre={ReclamationFiltre.ARelancer} anchor={ReclamationFiltreNoms[ReclamationFiltre.ARelancer]} />}

                        <ReclamationsDrawerListItem expanded={expanded} selected={filtre === ReclamationFiltre.Toutes} filtre={ReclamationFiltre.Toutes} anchor={ReclamationFiltreNoms[ReclamationFiltre.Toutes]} />
                        
                        {
                            utilisateurMagasin && (
                                <React.Fragment>
                                    <Divider className={classes.divider} />
                                    <ReclamationsDrawerListItem expanded={expanded} selected={filtre === ReclamationFiltre.RetourPlateforme} filtre={ReclamationFiltre.RetourPlateforme} anchor={ReclamationFiltreNoms[ReclamationFiltre.RetourPlateforme]}/>
                                </React.Fragment>
                            )
                        }
                    </List>

                    <div className={classNames(classes.drawerFooter, expanded && classes.drawerPaperClose)}>
                        <Divider />
                        {!expanded && (
                            <ListItem button onClick={this.toggleExpanded} className={classes.listItem}>
                                <ListItemIcon >
                                    <SvgIcon className={classes.listItemIcon} style={{ width: '24px', height: '24px' }} viewBox="0 0 24 24">
                                        <path d="M5.59,7.41L7,6L13,12L7,18L5.59,16.59L10.17,12L5.59,7.41M11.59,7.41L13,6L19,12L13,18L11.59,16.59L16.17,12L11.59,7.41Z" />
                                    </SvgIcon>
                                </ListItemIcon>
                            </ListItem>
                        )}

                        {expanded && (
                            <ListItem button onClick={this.toggleExpanded} className={classes.listItem}>
                                <ListItemIcon>
                                    <SvgIcon className={classes.listItemIcon} style={{ width: '24px', height: '24px' }} viewBox="0 0 24 24">
                                        <path d="M18.41,7.41L17,6L11,12L17,18L18.41,16.59L13.83,12L18.41,7.41M12.41,7.41L11,6L5,12L11,18L12.41,16.59L7.83,12L12.41,7.41Z" />
                                    </SvgIcon>
                                </ListItemIcon>
                            </ListItem>
                        )}
                    </div>
                </Drawer>

                <div className={classNames(classes.content, expanded && classes.contentClose)}>
                    <ReclamationsSearchFilters filtre={filtre}/>

                    <ReclamationsSearchResults filtre={filtre}/>
                </div>
            </div>
        );
    }
}

ReclamationsPage.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(ReclamationsPage);